/**
 * @fileoverview The ONE name of the attribute that marks the head elements the SEO layer owns
 * (LIFE-SHORTLISTED-001 U12(c), N247 row 3).
 *
 * `<MarketingSeo>` (`@puffin-core/marketing-shell`) stamps it on every head element it writes, so a
 * later render replaces its own elements in place, and the marketing prerender plugin
 * (`@puffin-core/shared-config`) writes it on the JSON-LD it injects, so hydration adopts those
 * blocks instead of appending a second copy. Both read it from here. It ships in the head of every
 * public tenant site, so it names no platform: a tenant's page must not carry the platform's brand.
 *
 * Its own subpath (`@puffin-core/seo/managed-head`), because a browser bundle reached through the
 * package root receives the root's whole CJS graph (see `schemaOrgSubpath.test.js`).
 *
 * @module @puffin-core/seo/managedHead
 */

'use strict';

/** The data attribute on every SEO-owned head element. */
const SEO_MANAGED_HEAD_ATTR = 'data-seo-managed';

module.exports = { SEO_MANAGED_HEAD_ATTR };
